
export enum AlertSeverity {
    SUCCESS = "success",
    INFO = "info",
    WARNING = "warning",
    ERROR = "error"
}

export interface EstablishmentPaymentDialogState {
    paymentMapping: {
        pos_card: string
        pos_lunchvoucher: string
        online_card: string
        online_wallet: string
        online_bancontact: string
        online_lunchvoucher: string
        online_intercard: string
        online_bankroll: string
        online_epro: string
    } & {
        [key: string]: string
    }
}
